import { render, staticRenderFns } from "./EmailPreferences.vue?vue&type=template&id=9831f072&"
import script from "./EmailPreferences.vue?vue&type=script&lang=ts&"
export * from "./EmailPreferences.vue?vue&type=script&lang=ts&"
import style0 from "./EmailPreferences.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports